import * as list from './list.ts';
import * as ll from './ll.ts';
import * as why from './why.ts';

export { list, ll, why };
